import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
// import reportWebVitals from './reportWebVitals';
// import * as serviceWorker from "./serviceWorker";
import './styles/css/fonts.css'

import rootLauncher from './components/launchers/rootLauncher';
import LoaderAnimated from './components/abstract/loaders/loaderAnimated';

// Launch separarate widgets on the pages
rootLauncher()

// Start the app that renders complete pages
const reactPage = document.getElementById('react-page'); 
if(reactPage){
  const App = React.lazy(() => import('./App'));
  ReactDOM.render(
    <React.StrictMode>
      <Suspense fallback={<LoaderAnimated animated={false} />}>
        <App />
      </Suspense>
    </React.StrictMode>
  , reactPage);
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);

// serviceWorker.register()
